export const navigateSecurely = (url?: string): void => {
  const targetUrl = url || process.env.REACT_APP_LOGIN_URL || "/";

  const link = document.createElement("a");
  link.href = targetUrl;

  link.rel = "noreferrer";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
